import type { CodeServiceTva } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

const getCodesServiceTva = () =>
	request.get<unknown, TemplateRequestGet<CodeServiceTva>>(
		'/api/finances/comptabilite/piecescomptables/codesServiceTva?all=true',
	);

export default getCodesServiceTva;
